import { render, staticRenderFns } from "./Vis.vue?vue&type=template&id=51679fa9&"
import script from "./Vis.vue?vue&type=script&lang=js&"
export * from "./Vis.vue?vue&type=script&lang=js&"
import style0 from "./Vis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports